/* Enzomar: shows the selected Gold Color's bar thumbnail next to the closed dropdown value (CSS draws it from data-enz-gold). Variant logic is untouched. */
(function(){
 function key(t){return (t||'').trim().toLowerCase().replace(/\s+/g,'-');}
 function sync(opt){var v=opt.querySelector('[data-swatch-list] > button [data-current-value]');if(v)opt.setAttribute('data-enz-gold',key(v.textContent));}
 function init(){document.querySelectorAll('.is-t4s-name__gold-color').forEach(function(opt){
  if(opt._enzGold)return;opt._enzGold=1;sync(opt);
  new MutationObserver(function(){sync(opt);}).observe(opt,{subtree:true,childList:true,characterData:true});});}
 function start(){init();new MutationObserver(init).observe(document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* Enzomar: the star / "Be the first to review" link under the product title scrolls to the Judge.me widget (the theme's own hash handling does not reach app blocks). */
document.addEventListener('click',function(e){
 var a=e.target.closest&&e.target.closest('a.enz-rating');if(!a)return;
 var t=document.getElementById('judgeme_product_reviews')||document.querySelector('.jdgm-review-widget');if(!t)return;
 e.preventDefault();
 var y=t.getBoundingClientRect().top+window.pageYOffset-90;window.scrollTo({top:Math.max(0,y),behavior:'smooth'});
 if(history.replaceState)history.replaceState(null,'','#judgeme_product_reviews');
});

/* Enzomar: product-page accordions (<details class="enz-acc">): all closed on load, smooth open/close, and only one open at a time (opening one closes the others). */
(function(){
 var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 function setState(d,opening){
  var b=d.querySelector('.enz-acc__body');if(!b)return;
  if(d._enzAnim){d._enzAnim.cancel();clearTimeout(d._enzTimer);d._enzAnim=null;}
  if(d.open===opening&&!d.classList.contains('is-closing'))return;
  if(reduce||!b.animate){d.open=opening;d.classList.remove('is-closing');return;}
  var ms=260,token={};d._enzToken=token;
  var finish=function(){if(d._enzToken!==token)return;d._enzToken=null;if(d._enzAnim){d._enzAnim.cancel();d._enzAnim=null;}clearTimeout(d._enzTimer);d.open=opening;d.classList.remove('is-closing');b.style.height='';b.style.opacity='';};
  if(opening){d.open=true;d.classList.remove('is-closing');var h=b.offsetHeight;d._enzAnim=b.animate([{height:'0px',opacity:0},{height:h+'px',opacity:1}],{duration:ms,easing:'ease'});}
  else{d.classList.add('is-closing');var h2=b.offsetHeight;d._enzAnim=b.animate([{height:h2+'px',opacity:1},{height:'0px',opacity:0}],{duration:ms,easing:'ease'});}
  d._enzTimer=setTimeout(finish,ms+40);
 }
 document.addEventListener('click',function(e){
  var s=e.target.closest&&e.target.closest('.enz-acc>summary');if(!s)return;
  var d=s.parentNode;e.preventDefault();
  var opening=!d.open||d.classList.contains('is-closing');
  if(opening){var group=d.closest('.enz-details')||document;group.querySelectorAll('.enz-acc').forEach(function(o){if(o!==d&&(o.open&&!o.classList.contains('is-closing')))setState(o,false);});}
  setState(d,opening);
 });
})();

/* Enzomar: product-card hover video. Only a card that really has a Shopify video (data-enz-video, set in snippets/product-img.liquid) loads one;
   it starts on hover (muted, looping, inline), stops on leave and falls back to the photo on any problem. Not used on touch devices or with reduced motion. */
(function(){
 var canHover=window.matchMedia&&window.matchMedia('(hover: hover) and (pointer: fine)').matches;
 var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 if(!canHover||reduce)return;
 function box(el){var inner=el.closest&&el.closest('.t4s-product-inner');return inner?inner.querySelector('.t4s-product-img[data-enz-video]'):null;}
 function start(img){
  if(img._enzFailed)return;
  var v=img._enzVideo;
  if(!v){
   v=document.createElement('video');v.className='enz-card-video';v.muted=true;v.defaultMuted=true;v.loop=true;v.playsInline=true;v.setAttribute('playsinline','');v.setAttribute('muted','');v.preload='none';v.setAttribute('aria-hidden','true');v.tabIndex=-1;
   v.addEventListener('playing',function(){if(img._enzHover)v.classList.add('is-playing');});
   v.addEventListener('error',function(){img._enzFailed=true;if(v.parentNode)v.parentNode.removeChild(v);img._enzVideo=null;});
   v.src=img.getAttribute('data-enz-video');img.appendChild(v);img._enzVideo=v;
  }
  var p=v.play();if(p&&p.catch)p.catch(function(){});
 }
 function stop(img){var v=img._enzVideo;if(!v)return;v.classList.remove('is-playing');v.pause();try{v.currentTime=0;}catch(e){}}
 document.addEventListener('mouseover',function(e){var img=box(e.target);if(!img||img._enzHover)return;img._enzHover=true;start(img);});
 document.addEventListener('mouseout',function(e){var img=box(e.target);if(!img||!img._enzHover)return;var to=e.relatedTarget;if(to&&img.closest('.t4s-product-inner').contains(to))return;img._enzHover=false;stop(img);});
})();

/* Enzomar: on the product page the wishlist heart sits directly above the first option (e.g. Material) instead of next to Add to Cart. The theme's own wishlist code is untouched (it listens on the document). */
(function(){
 var busy=false;
 function place(){
  if(busy)return;var a=document.querySelector('.t4s-product-form__buttons .t4s-pr-wishlist');var first=document.querySelector('.t4s-swatch__option');
  if(!a||!first)return;busy=true;
  var wrap=document.querySelector('.enz-pdp-wish');
  if(!wrap){wrap=document.createElement('div');wrap.className='enz-pdp-wish';first.parentNode.insertBefore(wrap,first);}
  a.removeAttribute('data-tooltip');a.classList.remove('t4s-tooltip-actived');wrap.appendChild(a);busy=false;
 }
 function start(){place();var root=document.querySelector('.t4s-form__product')||document.body;new MutationObserver(place).observe(root,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
